import { Reveal } from "./Reveal";

export const Chapter = ({ index, label, title, lead, dark = false, className = "" }) => (
  <Reveal className={className}>
    <p className={`nv-pill font-mono2 text-[10px] uppercase tracking-[0.24em] sm:text-xs ${dark ? "" : ""}`}>
      <span className="nv-dot" aria-hidden="true" />
      {index} // {label}
    </p>
    <h2
      className={`font-display mt-4 text-lg md:text-xl font-bold tracking-tight uppercase ${
        dark ? "nv-head" : "nv-head"
      }`}
    >
      {title}
    </h2>
    {lead && (
      <p className={`mt-4 max-w-2xl text-base leading-relaxed ${dark ? "text-[#41535F]" : "text-[#41535F]"}`}>{lead}</p>
    )}
  </Reveal>
);

export default Chapter;
